/**
 * Guard buffs (data/guardBuffs.ts): a buff move arms the caster; the first blow they block spends the arming and grants the
 * buff's real effect. Observes `hit` events only; no timers of its own (the status runs out by the World's status clock).
 */
import { GUARD_BUFFS } from '../data/guardBuffs';
import { RAGE } from '../data/skills';
import { stacksOf } from '../status';
import type { WorldEvent } from '../world';
import type { SystemHost, WorldSystem } from './types';

export class GuardBuffSystem implements WorldSystem {
  readonly name = 'guardBuff';

  constructor(private readonly h: SystemHost) {}

  observe(e: WorldEvent): void {
    if (e.type !== 'hit' || e.outcome !== 'blocked') return;
    const w = this.h.world;
    const t = w.get(e.tgtId);
    if (!t || t.dead) return;
    for (const g of Object.values(GUARD_BUFFS)) {
      if (stacksOf(t.statuses, g.armed) <= 0) continue;
      w.addStatus(t, g.armed, -1);
      w.addStatus(t, g.grants, 1);
      if (g.rage) t.rage = Math.min(RAGE.max, t.rage + g.rage);
      if (g.qi) t.qi = Math.min(t.maxQi, t.qi + g.qi);
      if (g.healPct) t.hp = Math.min(t.maxHp, t.hp + t.maxHp * g.healPct);
    }
  }
}
